import './utils/_webpackPath.js';
import '@ungap/custom-elements';
import whatInput from 'what-input'; // eslint-disable-line no-unused-vars
import { initBreakpoints } from './utils/_breakpoints.js';

// Javascript Tools
require('./atoms/_a-captcha.js'); // initiate global function for Google Captcha
const customSelect = require('./utils/_customSelect.js'); // initiate custom select with Choices.js

// Atoms
require('./atoms/_a-bp-grid.js');
require('./atoms/_a-btn-sizeguide.js');
require('./atoms/_a-btn-toggle-input.js');
require('./atoms/_a-cta-box-anchor.js');
require('./atoms/_a-cta-box-button.js');
require('./atoms/_a-cta-text-anchor.js');
require('./atoms/_a-cta-text-button.js');
require('./atoms/_a-language-switcher.js');
require('./atoms/_a-toggle-switch.js');
require('./atoms/_a-btn-add-to-calendar.js');

// Molecules
require('./molecules/_m-accordion.js');
require('./molecules/_m-ajax-form.js');
require('./molecules/_m-tile-slider.js');
require('./molecules/_m-tile-overlay.js');
require('./molecules/_m-plp-tile-slider-size.js');
require('./molecules/_m-tile-color.js');
require('./molecules/_m-quickview.js');
require('./molecules/_m-text-loop.js');
require('./molecules/_m-popin.js');
require('./molecules/_m-wishlist-alert.js');
require('./molecules/_m-backtotop.js');
require('./molecules/_m-range.js');
require('./molecules/_m-see-more.js');
require('./molecules/_m-load-previous.js');
require('./molecules/_m-pdp-images.js');
require('./molecules/_m-pdp-infos.js');
require('./molecules/_m-pdp-actions.js');
require('./molecules/_m-pdp-bar.js');
require('./molecules/_m-reco-slider.js');
require('./molecules/_m-fullscreen-images.js');
require('./molecules/_m-carrousel.js');
require('./molecules/_m-address-suggestions.js');
require('./molecules/_m-account-profile.js');
require('./molecules/_m-reveal.js');
require('./molecules/_m-header-banner.js');
require('./molecules/_m-editable-field.js');
require('./molecules/_m-card-address.js');
require('./molecules/_m-page-with-menu.js');
require('./molecules/_m-form-submit-buttons.js');
require('./molecules/_m-form-password-fields.js');
require('./molecules/_m-popin-images.js');
require('./molecules/_m-product-tile.js');
require('./molecules/_m-product-card.js');
require('./molecules/_m-tile-video.js');
require('./molecules/_m-stores-search.js');
require('./molecules/_m-stores-carousel.js');
require('./molecules/_m-gender.js');
require('./molecules/_m-find-in-store.js');
require('./molecules/_m-order-return-panel.js');
require('./molecules/_m-select-country.js');
require('./molecules/_m-form-postal-code.js');
require('./molecules/_m-gtm-event.js');
require('./molecules/_m-info-bubble.js');
require('./molecules/_m-video.js');
require('./molecules/_m-plp-hero.js');
require('./molecules/_m-minicart-empty.js');
require('./molecules/_m-cancel-order.js');
require('./molecules/_m-combobox.js');
require('./molecules/_m-date-picker.js');
require('./molecules/_m-date-picker-menu.js');
require('./molecules/_m-date-picker-field.js');
require('./molecules/_m-checkout-stepper.js');
require('./molecules/_m-address-selector.js');
require('./molecules/_m-address-selector-card.js');
require('./molecules/_m-phone-field.js');
require('./molecules/_m-nps-diduenjoy.js');
require('./molecules/_m-form-login-sidebar.js');
require('./molecules/_m-checkout-login-register-globale.js');
require('./molecules/_m-account-address-book.js');
require('./molecules/_m-plp-quick-links.js');
require('./molecules/_m-back-btn.js');

// Molecules Store locator
require('./molecules/_m-store-locator-slider.js');
require('./molecules/_m-store-locator-header.js');

// Molecules Page designer specific
require('./molecules/_m-homepage-multislider.js');
require('./molecules/_m-homepage-slider.js');
require('./molecules/_m-pd-carrousel.js');
require('./molecules/_m-pd-carrousel-packshots.js');
require('./molecules/_m-pd-carrousel-scroll.js');
require('./molecules/_m-pd-video-scroll.js');
require('./molecules/_m-pd-verdy-logo-bounce.js');
require('./molecules/_m-countdown.js');

// Molecules FAQ
require('./molecules/_m-faq-bar.js');

// Organisms
require('./organisms/_o-sidebar.js');
require('./organisms/_o-filters.js');
require('./organisms/_o-sidebar-ajax.js');
require('./organisms/_o-sidebar-manager.js');
require('./organisms/_o-plp-grid.js');
require('./organisms/_o-faq-grid.js');
require('./organisms/_o-init-reco.js');
require('./organisms/_o-cart.js');
require('./organisms/_o-navigation.js');
require('./organisms/_o-wishlist.js');
require('./organisms/_o-storelocator-filters.js');
require('./organisms/_o-store-locator.js');
require('./organisms/_o-search.js');
require('./organisms/_o-gtm.js');
require('./organisms/_o-delivery.js');
require('./organisms/_o-checkout.js');
require('./organisms/_o-minicart-cookie.js');
require('./organisms/_o-gift-card.js');
require('./organisms/_o-gift-card-balance.js');

document.addEventListener('DOMContentLoaded', () => {
    // Dom is ready
    window.breakpoints = initBreakpoints();
    customSelect.initCustomSelect();
});
